import { Conn } from './conn';
import { Conn_Db } from './conn_db';
import { Conn_Usr } from './conn_usr';
import { Flagent_Grp } from './flagent_grp';
import { Db_PropertyType } from './dbPropertyType';
import { Conn_Obj_Property } from './connObjProperty';
import { CloudPlatform } from './cloudPlatform';
import { Obj_Db_Property } from './obj_db_property';
import { CommonEnums } from '../../common.enums';
import { Flagent } from './flagent';
import { Conn_DbsUtil } from '../../utils/conn_dbs.util';
import { CloudPlatformsUtil } from '../../utils/cloudplatforms.util';
import { Conn_Obj_PropertiesUtil } from '../../utils/conn_obj_properties.util';
import { Obj_Db_PropertiesUtil } from '../../utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from '../../utils/db_propertytypes.util';

export class RepConn {
    conn: Conn;
    conn_Usr: Conn_Usr;
    flagent: Flagent;
    flagent_Grp: Flagent_Grp;

    conn_Dbs: Array<Conn_Db>;
    extract_Properties: Array<Obj_Db_Property>;
    load_Properties: Array<Obj_Db_Property>;
    run_Properties: Array<Obj_Db_Property>;
    header_Properties: Array<Obj_Db_Property>;
    rest_Properties: Array<Obj_Db_Property>;
    pagination_Properties: Array<Obj_Db_Property>;
    conn_Obj_Properties: Array<Conn_Obj_Property>;
    dependent_Ids: Array<number>; //SET
    cloudPlatforms: Array<CloudPlatform>;

    extractPropertyTypes: Array<Db_PropertyType>;
    loadPropertyTypes: Array<Db_PropertyType>;
    runPropertyTypes: Array<Db_PropertyType>;

    reusableFlag: string;
    fldr_Id: number;
    dependent: boolean;
    lockBy: string;
    mode_Ind: string;
    unlock_Ind: string;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    linkExist: boolean;
    fldrNm: string;
    totalItemsCount: number;
    imageUrl: string;
    sel_Extract_PropertyType_Cd: string;
    sel_Load_PropertyType_Cd: string;
    recExists: boolean;
    sel_Run_PropertyType_Cd: string;
    selectedFlag: string;
    fldr_Cd: string;
    isCompletelyLoaded: string;
    itemsCount: number;
    licensedNativeFlag: string;
    forceFlag: string;
    isMssqlSelectedDBNm: string;
    isMssqlSchemaSel: string;

    constructor() {
        this.setDefaults();
    }

    setDefaults(): void {
        this.conn = new Conn();
        this.conn_Usr = new Conn_Usr();
        this.flagent = new Flagent();
        this.flagent_Grp = new Flagent_Grp();

        let conn_Db: Conn_Db = new Conn_Db();
        this.conn_Dbs = new Array<Conn_Db>();
        // this.conn_Dbs.push(conn_Db);
        this.conn_Obj_Properties = new Array<Conn_Obj_Property>();
        this.extract_Properties = new Array<Obj_Db_Property>();
        this.load_Properties = new Array<Obj_Db_Property>();
        this.extractPropertyTypes = new Array<Db_PropertyType>();
        this.loadPropertyTypes = new Array<Db_PropertyType>();
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();
        this.dependent_Ids = new Array<number>(); //SET
        this.header_Properties = new Array<Obj_Db_Property>();
        this.rest_Properties = new Array<Obj_Db_Property>();
        this.pagination_Properties = new Array<Obj_Db_Property>();
        this.cloudPlatforms = new Array<CloudPlatform>();

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.ERROR_CD;
        this.error_Msg = CommonEnums.defaults.ERROR_MSG;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.lockBy = CommonEnums.defaults.STRING_EMPTY;
        this.mode_Ind = CommonEnums.mode_Ind.WRITE;
        this.unlock_Ind = CommonEnums.unlock_Ind.UNSET;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.reusableFlag = CommonEnums.reusableFlag.NO;
        this.fldrNm = CommonEnums.defaults.STRING_EMPTY;
        this.totalItemsCount = CommonEnums.defaults.ZERO;
        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
        this.sel_Extract_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.sel_Load_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.itemsCount = CommonEnums.defaults.ZERO;
        this.selectedFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.fldr_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.isCompletelyLoaded = CommonEnums.defaults.STRING_VAL_NO;
        this.licensedNativeFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.dependent = false;
        this.linkExist = false;
        this.recExists = false;
        this.forceFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.isMssqlSchemaSel = CommonEnums.defaults.STRING_VAL_NO;
        this.isMssqlSelectedDBNm = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(object: any): RepConn {
        let repconn: RepConn = new RepConn();
        repconn.copyFrom(object as RepConn);
        return repconn;
    }

    copy(): RepConn {
        let repConnTmp: RepConn = new RepConn();

        this.conn.copyFrom(repConnTmp.conn);
        this.conn_Usr.copyFrom(repConnTmp.conn_Usr);
        this.flagent.copyFrom(repConnTmp.flagent);
        this.flagent_Grp.copyFrom(repConnTmp.flagent_Grp);

        Conn_DbsUtil.getInstance().copyFrom(this.conn_Dbs, repConnTmp.conn_Dbs);
        CloudPlatformsUtil.getInstance().copyFrom(this.cloudPlatforms, repConnTmp.cloudPlatforms);
        Conn_Obj_PropertiesUtil.getInstance().copyFrom(this.conn_Obj_Properties, repConnTmp.conn_Obj_Properties);

        let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
        obj_Db_PropertiesUtil.copyFrom(this.extract_Properties, repConnTmp.extract_Properties);
        obj_Db_PropertiesUtil.setShowOn(this.extract_Properties, true, this.sel_Extract_PropertyType_Cd);
        obj_Db_PropertiesUtil.setShowOn(this.extract_Properties, false, this.sel_Extract_PropertyType_Cd);

        obj_Db_PropertiesUtil.copyFrom(this.load_Properties, repConnTmp.load_Properties);
        obj_Db_PropertiesUtil.setShowOn(this.load_Properties, true, this.sel_Load_PropertyType_Cd);
        obj_Db_PropertiesUtil.setShowOn(this.load_Properties, false, this.sel_Load_PropertyType_Cd);

        obj_Db_PropertiesUtil.copyFrom(this.run_Properties, repConnTmp.run_Properties);
        obj_Db_PropertiesUtil.setShowOn(this.run_Properties, true, this.sel_Run_PropertyType_Cd);
        obj_Db_PropertiesUtil.setShowOn(this.run_Properties, false, this.sel_Run_PropertyType_Cd);

        obj_Db_PropertiesUtil.copyFrom(this.header_Properties, repConnTmp.header_Properties);
        obj_Db_PropertiesUtil.copyFrom(this.rest_Properties, repConnTmp.rest_Properties);
        obj_Db_PropertiesUtil.copyFrom(this.pagination_Properties, repConnTmp.pagination_Properties);

        let db_PropertyTypesUtil: Db_PropertyTypesUtil = Db_PropertyTypesUtil.getInstance();
        db_PropertyTypesUtil.copyFrom(this.extractPropertyTypes, repConnTmp.extractPropertyTypes);
        db_PropertyTypesUtil.copyFrom(this.loadPropertyTypes, repConnTmp.loadPropertyTypes);
        db_PropertyTypesUtil.copyFrom(this.runPropertyTypes, repConnTmp.runPropertyTypes);

        this.lockBy = repConnTmp.lockBy;
        this.mode_Ind = repConnTmp.mode_Ind;
        this.unlock_Ind = repConnTmp.unlock_Ind;

        this.change_Ind = repConnTmp.change_Ind;
        this.error_Cd = repConnTmp.error_Cd;
        this.error_Msg = repConnTmp.error_Msg;
        this.fldr_Id = repConnTmp.fldr_Id;
        this.ref_Id = repConnTmp.ref_Id;
        this.ref_Cd = repConnTmp.ref_Cd;

        this.dependent_Ids = repConnTmp.dependent_Ids;
        this.reusableFlag = repConnTmp.reusableFlag;
        this.dependent = repConnTmp.dependent;

        this.linkExist = repConnTmp.linkExist;
        this.fldrNm = repConnTmp.fldrNm;
        this.totalItemsCount = repConnTmp.totalItemsCount;
        this.imageUrl = repConnTmp.imageUrl;
        this.sel_Extract_PropertyType_Cd = repConnTmp.sel_Extract_PropertyType_Cd;
        this.sel_Load_PropertyType_Cd = repConnTmp.sel_Load_PropertyType_Cd;
        this.recExists = repConnTmp.recExists;
        this.sel_Run_PropertyType_Cd = repConnTmp.sel_Run_PropertyType_Cd;
        this.selectedFlag = repConnTmp.selectedFlag;
        this.fldr_Cd = repConnTmp.fldr_Cd;
        this.isCompletelyLoaded = repConnTmp.isCompletelyLoaded;
        this.itemsCount = repConnTmp.itemsCount;
        this.cloudPlatforms = repConnTmp.cloudPlatforms;
        this.licensedNativeFlag = repConnTmp.licensedNativeFlag;
        this.forceFlag = repConnTmp.forceFlag;
        this.isMssqlSchemaSel = repConnTmp.isMssqlSchemaSel;
        this.isMssqlSelectedDBNm = repConnTmp.isMssqlSelectedDBNm;
        return repConnTmp;
    }

    copyFrom(repConnTmp: any): void {
        this.conn = Conn.parse(repConnTmp.conn);
        this.conn_Usr.copyFrom(repConnTmp.conn_Usr);
        this.flagent.copyFrom(repConnTmp.flagent);
        this.flagent_Grp.copyFrom(repConnTmp.flagent_Grp);

        Conn_DbsUtil.getInstance().copyFrom(this.conn_Dbs, repConnTmp.conn_Dbs);
        CloudPlatformsUtil.getInstance().copyFrom(this.cloudPlatforms, repConnTmp.cloudPlatforms);
        Conn_Obj_PropertiesUtil.getInstance().copyFrom(this.conn_Obj_Properties, repConnTmp.conn_Obj_Properties);



        this.lockBy = repConnTmp.lockBy;
        this.mode_Ind = repConnTmp.mode_Ind;
        this.unlock_Ind = repConnTmp.unlock_Ind;

        this.change_Ind = repConnTmp.change_Ind;
        this.error_Cd = repConnTmp.error_Cd;
        this.error_Msg = repConnTmp.error_Msg;
        this.fldr_Id = repConnTmp.fldr_Id;
        this.ref_Id = repConnTmp.ref_Id;
        this.ref_Cd = repConnTmp.ref_Cd;

        this.dependent_Ids = repConnTmp.dependent_Ids;
        this.reusableFlag = repConnTmp.reusableFlag;
        this.dependent = repConnTmp.isDependent;

        this.linkExist = repConnTmp.isLinkExist;
        this.fldrNm = repConnTmp.fldrNm;
        this.totalItemsCount = repConnTmp.totalItemsCount;
        this.imageUrl = repConnTmp.imageUrl;
        this.sel_Extract_PropertyType_Cd = repConnTmp.sel_Extract_PropertyType_Cd;
        this.sel_Load_PropertyType_Cd = repConnTmp.sel_Load_PropertyType_Cd;
        this.recExists = repConnTmp.isRecExists;
        this.sel_Run_PropertyType_Cd = repConnTmp.sel_Run_PropertyType_Cd;
        this.selectedFlag = repConnTmp.selectedFlag;
        this.fldr_Cd = repConnTmp.fldr_Cd;
        this.isCompletelyLoaded = repConnTmp.isCompletelyLoaded;
        this.itemsCount = repConnTmp.itemsCount;
        this.cloudPlatforms = repConnTmp.cloudPlatforms;
        this.licensedNativeFlag = repConnTmp.licensedNativeFlag;
        this.forceFlag = repConnTmp.forceFlag;
        this.isMssqlSchemaSel = repConnTmp.isMssqlSchemaSel;
        this.isMssqlSelectedDBNm = repConnTmp.isMssqlSelectedDBNm;

        let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
        obj_Db_PropertiesUtil.copyFrom(this.extract_Properties, repConnTmp.extract_Properties);
        obj_Db_PropertiesUtil.setShowOn(this.extract_Properties, true, this.sel_Extract_PropertyType_Cd);
        obj_Db_PropertiesUtil.setShowOn(this.extract_Properties, false, this.sel_Extract_PropertyType_Cd);

        obj_Db_PropertiesUtil.copyFrom(this.load_Properties, repConnTmp.load_Properties);
        obj_Db_PropertiesUtil.setShowOn(this.load_Properties, true, this.sel_Load_PropertyType_Cd);
        obj_Db_PropertiesUtil.setShowOn(this.load_Properties, false, this.sel_Load_PropertyType_Cd);

        obj_Db_PropertiesUtil.copyFrom(this.run_Properties, repConnTmp.run_Properties);
        obj_Db_PropertiesUtil.setShowOn(this.run_Properties, true, this.sel_Run_PropertyType_Cd);
        obj_Db_PropertiesUtil.setShowOn(this.run_Properties, false, this.sel_Run_PropertyType_Cd);

        obj_Db_PropertiesUtil.copyFrom(this.header_Properties, repConnTmp.header_Properties);
         obj_Db_PropertiesUtil.copyFrom(this.rest_Properties, repConnTmp.rest_Properties);
         obj_Db_PropertiesUtil.copyFrom(this.pagination_Properties, repConnTmp.pagination_Properties);

        let db_PropertyTypesUtil: Db_PropertyTypesUtil = Db_PropertyTypesUtil.getInstance();
        db_PropertyTypesUtil.copyFrom(this.extractPropertyTypes, repConnTmp.extractPropertyTypes);
        db_PropertyTypesUtil.copyFrom(this.loadPropertyTypes, repConnTmp.loadPropertyTypes);
        db_PropertyTypesUtil.copyFrom(this.runPropertyTypes, repConnTmp.runPropertyTypes);

    }

    compare(repConnTmp: RepConn): string {
        let diffString = '';

        diffString = this.conn.compare(repConnTmp.conn);
        if (diffString != '') return diffString;

        diffString = this.conn_Usr.compare(repConnTmp.conn_Usr)
        if (diffString != '') return diffString;


        diffString = this.flagent.compare(repConnTmp.flagent)
        if (diffString != '') return diffString;

        diffString = this.flagent_Grp.compare(repConnTmp.flagent_Grp)
        if (diffString != '') return diffString;


        let obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();

        diffString = obj_Db_PropertiesUtil.compare(this.extract_Properties, repConnTmp.extract_Properties)
        if (diffString != '') return diffString;


        let conn_DbsUtil = Conn_DbsUtil.getInstance();

        diffString = conn_DbsUtil.compare(this.conn_Dbs, repConnTmp.conn_Dbs)
        if (diffString != '') return diffString;


        if (this.sel_Extract_PropertyType_Cd != repConnTmp.sel_Extract_PropertyType_Cd) {
            diffString = 'Not equel sel_Extract_PropertyType_Cd'
            return;
        }

        if (this.sel_Load_PropertyType_Cd != repConnTmp.sel_Load_PropertyType_Cd) {
            diffString = 'Not equel sel_Load_PropertyType_Cd'
            return;
        }

        if (this.sel_Run_PropertyType_Cd != repConnTmp.sel_Run_PropertyType_Cd) {
            diffString = 'Not equel sel_Run_PropertyType_Cd'
            return;
        }

        diffString = obj_Db_PropertiesUtil.compare(this.header_Properties, repConnTmp.header_Properties)
        if (diffString != '') return diffString;

        diffString = obj_Db_PropertiesUtil.compare(this.rest_Properties, repConnTmp.rest_Properties)
        if (diffString != '') return diffString;

        diffString = obj_Db_PropertiesUtil.compare(this.pagination_Properties, repConnTmp.pagination_Properties)
        if (diffString != '') return diffString;

        diffString = obj_Db_PropertiesUtil.compare(this.extract_Properties, repConnTmp.extract_Properties)
        if (diffString != '') return diffString;

        diffString = obj_Db_PropertiesUtil.compare(this.load_Properties, repConnTmp.load_Properties)
        if (diffString != '') return diffString;

        diffString = obj_Db_PropertiesUtil.compare(this.run_Properties, repConnTmp.run_Properties)
        if (diffString != '') return diffString;

        let conn_Obj_PropertiesUtil = Conn_Obj_PropertiesUtil.getInstance();

        diffString = conn_Obj_PropertiesUtil.compare(this.conn_Obj_Properties, repConnTmp.conn_Obj_Properties)
        if (diffString != '') return diffString;

        return diffString;
    }

    toString(): string {
        let str: string = 'RepConn' + ' :: ';
        str += ', fldr_Id: ' + this.fldr_Id;
        str += ', ref_Id: ' + this.ref_Id;
        str += ', ref_Cd: ' + this.ref_Cd;
        str += ', flagent: ' + this.flagent;
        str += ', unlock_Ind: ' + this.unlock_Ind;
        str += ', lockBy: ' + this.lockBy;
        str += ', mode_Ind: ' + this.mode_Ind;
        str += ', change_Ind: ' + this.change_Ind;
        str += ', error_Cd: ' + this.error_Cd;
        str += ', error_Msg: ' + this.error_Msg + '\n';
        str += ', header_Properties: ' + this.header_Properties + '\n'
        str += ', rest_Properties: ' + this.rest_Properties + '\n'
        str += ', pagination_Properties: ' + this.pagination_Properties + '\n'
        str += ', dependent_Ids: ' + this.dependent_Ids + '\n'

        if (this.conn != null)
            str += 'Conn: ' + this.conn.toString() + '\n';

        if (this.conn_Usr != null)
            str += 'conn_Usr: ' + this.conn_Usr.toString() + '\n';

        str += '   Total Conn_Db: ' + this.conn_Dbs.length.toString() + '\n';

        for (let i = 0; i < this.conn_Dbs.length; i++) {
            let conndb = this.conn_Dbs[i];
            str += '      ' + conndb.toString() + '\n';
        }

        str += '   Total Conn_Obj_Properties: ' + this.conn_Obj_Properties.toString() + '\n';

        for (let connObjProperty in this.conn_Obj_Properties) {
            str += '' + connObjProperty.toString() + '\n';
        }

        return str;
    }
}
